export const BASE_API_URL = "https://vndev.hanbiro.com/dasanbooks/public/api";

export const URL_GET_ORG = "org/tree/org";
export const URL_GET_MENU = "post/menu";
export const URL_GET_CONFIG = "config/get";
export const URL_UPDATE_CONFIG = "org/user/setting";
